import TitleBox from "@/components/title.vue";
import RealCase from "@/components/real-case.vue";
import Product from "@/components/product.vue";
export default {
  name: "PrintBox",
  components: {
    TitleBox,
    RealCase,
    Product
  },
  data() {
    return {
      carouselList: [
        require("@/assets/college/live1.png"),
        require("@/assets/convenience/live3.png"),
        require("@/assets/college/live3.png")
      ]
    };
  },
  computed: {},
  methods: {}
};
